
import { defineComponent, PropType, reactive } from 'vue'
import { ListRequest } from '@/requests/message'
import { Message } from '@/api'
import { AxiosResponse } from 'axios'
import DateDisplay from '@/components/displays/DateDisplay.vue'
import MessageSenderOrRecipientName from '@/components/displays/MessageSenderOrRecipientName.vue'
import MessageHistoryBody from '@/components/displays/MessageHistoryBody.vue'

import { displaySenderOrRecipientName } from '@/services/messageAddress'

/**
 * メッセージ履歴の表示コンポーネント
 * 特定のメッセージ種別のみ表示
 */
export default defineComponent({
  name: 'MessageHistoryToMessageType',
  components: {
    DateDisplay,
    MessageSenderOrRecipientName,
    MessageHistoryBody,
  },
  props: {
    // 申請基本ID
    requestHeaderId: {
      type: Number,
      required: true,
    },
    //履歴表示対象メッセージ種別
    targetMessageTypes: {
      type: Array as PropType<number[]>,
      required: true,
    },
  },
  async setup(props) {
    const messages = reactive<Message[]>([])
    const request = new ListRequest(props.requestHeaderId)
    await request.exec()
    if (request.success) {
      const { data } = request.getResponse() as AxiosResponse<Message[]>

      //履歴表示対象のメッセージ種別のメッセージを取得
      const targetMessages = data.filter((message) => {
        return props.targetMessageTypes.includes(message.message_type)
      })
      messages.push(...targetMessages)
    }

    return {
      displaySenderOrRecipientName,
      messages,
    }
  },
})
